/**
 * @file 全局component注册
 */
import ZTIcon from './zt-icon';
import * as ztMessageBox from './zt-message-box';
// import ZTButton from './zt-button/index';
import {ztConfirmDialog} from './zt-confirm-dialog/index.js';
import ZTTimePickerRanger from './zt-time-picker-ranger';
import ZTFullLayout from './zt-full-layout';
import ZTModuleLoading from './moduleLoading.vue';

export default function installComponent(app) {
    app.component('zt-icon', ZTIcon);
    app.component('zt-time-picker-ranger', ZTTimePickerRanger);
    app.component('zt-full-layout', ZTFullLayout);
    app.component('zt-module-loading', ZTModuleLoading);
    // app.component('zt-button', ZTButton);
    // app.component('zt-confirm-dialog', ztConfirmDialog);

    app.config.globalProperties.$ztConfirm = ztMessageBox.ztConfirm;
    app.config.globalProperties.$ztAlert = ztMessageBox.ztAlert;
    app.config.globalProperties.$ztConfirmDialog = ztConfirmDialog;
}

const ZTConfirm = ztMessageBox.ztConfirm;
const ZTAlert = ztMessageBox.ztAlert;
const ZTConfirmDialog = ztConfirmDialog;
export {
    ZTConfirm,
    ZTAlert,
    ZTConfirmDialog
};